import { render, staticRenderFns } from "./SegmentationLimiter.vue?vue&type=template&id=fc80446c"
import script from "./SegmentationLimiter.vue?vue&type=script&lang=js"
export * from "./SegmentationLimiter.vue?vue&type=script&lang=js"
import style0 from "./SegmentationLimiter.vue?vue&type=style&index=0&id=fc80446c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports